var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t('heading.admin')))]),_c('p',[_vm._v(_vm._s(_vm.$t('message.please_choose_option_below')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }